'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _partial = require('react-utils/partial');

var _partial2 = _interopRequireDefault(_partial);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _UIButton = require('../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var I18N_PREFIX = 'salesUI.UIPaginator';

var getMinAndMaxPageNumbers = function getMinAndMaxPageNumbers(maxVisiblePageButtons, page, pageCount) {
  var buffer = (maxVisiblePageButtons - 1) / 2;

  var min = page - buffer;
  var max = page + buffer;
  var numPagesToShow = Math.min(maxVisiblePageButtons, pageCount);

  if (min < 1) {
    min = 1;
    max = min + maxVisiblePageButtons - 1;
  }
  if (max > pageCount) {
    max = Math.max(pageCount, 1);
    min = max - numPagesToShow + 1;
  }

  return [Math.floor(min), Math.floor(max)];
};

var UIPaginator = function (_PureComponent) {
  _inherits(UIPaginator, _PureComponent);

  function UIPaginator() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UIPaginator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UIPaginator.__proto__ || Object.getPrototypeOf(UIPaginator)).call.apply(_ref, [this].concat(args))), _this), _this.goToPage = function (page) {
      if (page === _this.props.page) return;
      _this.props.onPageChange((0, _SyntheticEvent2.default)(page));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UIPaginator, [{
    key: 'renderNumberedPages',
    value: function renderNumberedPages(maxVisiblePageButtons, page, pageCount, enabledPageLimit, disabledPageTooltipTitle) {
      var _getMinAndMaxPageNumb = getMinAndMaxPageNumbers(maxVisiblePageButtons, page, pageCount),
          _getMinAndMaxPageNumb2 = _slicedToArray(_getMinAndMaxPageNumb, 2),
          min = _getMinAndMaxPageNumb2[0],
          max = _getMinAndMaxPageNumb2[1];

      var links = [];

      for (var currentPage = min; currentPage <= max; currentPage++) {
        var isActive = currentPage === page;
        links.push(_react2.default.createElement(
          _UITooltip2.default,
          {
            disabled: enabledPageLimit == null || enabledPageLimit != null && currentPage <= enabledPageLimit,
            title: disabledPageTooltipTitle,
            key: currentPage - min
          },
          _react2.default.createElement(
            _UIButton2.default,
            {
              active: isActive,
              'aria-current': isActive ? 'true' : null,
              className: (0, _classnames2.default)('private-paginator__button', 'private-paginator__button--numeric', { 'private-paginator__button--active': isActive }),
              'data-page-number': currentPage,
              disabled: enabledPageLimit != null && currentPage > enabledPageLimit,
              key: currentPage - min,
              onClick: (0, _partial2.default)(this.goToPage, currentPage),
              responsive: false,
              size: 'xs',
              use: 'transparent'
            },
            _react2.default.createElement(
              'span',
              { className: 'sr-only' },
              isActive ? _I18n2.default.text(I18N_PREFIX + '.pageNumber.currentIndicator') : null,
              _I18n2.default.text(I18N_PREFIX + '.pageNumber.description')
            ),
            currentPage
          )
        ));
      }

      return links;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          disabledPageTooltipTitle = _props.disabledPageTooltipTitle,
          enabledPageLimit = _props.enabledPageLimit,
          maxVisiblePageButtons = _props.maxVisiblePageButtons,
          __onPageChange = _props.onPageChange,
          page = _props.page,
          pageCount = _props.pageCount,
          showFirstLastButtons = _props.showFirstLastButtons,
          showButtonLabels = _props.showButtonLabels,
          rest = _objectWithoutProperties(_props, ['className', 'disabledPageTooltipTitle', 'enabledPageLimit', 'maxVisiblePageButtons', 'onPageChange', 'page', 'pageCount', 'showFirstLastButtons', 'showButtonLabels']);

      var arrowButtonClassName = showButtonLabels ? '' : 'sr-only';

      return _react2.default.createElement(
        'nav',
        _extends({
          'aria-label': _I18n2.default.text(I18N_PREFIX + '.label'),
          className: (0, _classnames2.default)('private-paginator', className),
          'data-current-page': page,
          role: 'navigation'
        }, rest),
        _react2.default.createElement(
          'span',
          { className: 'private-paginator__backward-controls' },
          showFirstLastButtons ? _react2.default.createElement(
            _UIButton2.default,
            {
              'aria-label': _I18n2.default.text(I18N_PREFIX + '.firstPage.description'),
              className: 'private-paginator__button',
              'data-first-page': true,
              disabled: page < 2,
              key: 'first',
              onClick: (0, _partial2.default)(this.goToPage, 1),
              responsive: false,
              size: 'xs',
              use: 'transparent'
            },
            _react2.default.createElement(_UIIcon2.default, { className: 'private-paginator__icon', name: 'first' }),
            _react2.default.createElement(
              'span',
              { className: arrowButtonClassName },
              _I18n2.default.text(I18N_PREFIX + '.firstPage.label')
            )
          ) : null,
          _react2.default.createElement(
            _UIButton2.default,
            {
              'aria-label': _I18n2.default.text(I18N_PREFIX + '.previousPage.description'),
              className: 'private-paginator__button',
              'data-prev-page': true,
              disabled: page < 2,
              key: 'prev',
              onClick: (0, _partial2.default)(this.goToPage, Math.max(page - 1, 1)),
              responsive: false,
              size: 'xs',
              use: 'transparent'
            },
            _react2.default.createElement(_UIIcon2.default, { className: 'private-paginator__icon', name: 'left', size: 'xs' }),
            _react2.default.createElement(
              'span',
              { className: arrowButtonClassName },
              _I18n2.default.text(I18N_PREFIX + '.previousPage.label')
            )
          )
        ),
        _react2.default.createElement(
          'span',
          { className: 'private-paginator__numbers' },
          this.renderNumberedPages(maxVisiblePageButtons, page, pageCount, enabledPageLimit, disabledPageTooltipTitle)
        ),
        _react2.default.createElement(
          'span',
          { className: 'private-paginator__forward-controls' },
          _react2.default.createElement(
            _UIButton2.default,
            {
              'aria-label': _I18n2.default.text(I18N_PREFIX + '.nextPage.description'),
              className: 'private-paginator__button',
              'data-next-page': true,
              disabled: page >= pageCount || enabledPageLimit != null && page >= enabledPageLimit,
              key: 'next',
              onClick: (0, _partial2.default)(this.goToPage, Math.min(page + 1, pageCount)),
              responsive: false,
              size: 'xs',
              use: 'transparent'
            },
            _react2.default.createElement(
              'span',
              { className: arrowButtonClassName },
              _I18n2.default.text(I18N_PREFIX + '.nextPage.label')
            ),
            _react2.default.createElement(_UIIcon2.default, {
              className: 'private-paginator__icon',
              name: 'right',
              size: 'xs'
            })
          ),
          showFirstLastButtons ? _react2.default.createElement(
            _UIButton2.default,
            {
              'aria-label': _I18n2.default.text(I18N_PREFIX + '.lastPage.description'),
              className: 'private-paginator__button',
              'data-last-page': true,
              disabled: enabledPageLimit != null ? page >= enabledPageLimit : pageCount === page,
              key: 'last',
              onClick: (0, _partial2.default)(this.goToPage, enabledPageLimit != null ? enabledPageLimit : pageCount),
              responsive: false,
              size: 'xs',
              use: 'transparent'
            },
            _react2.default.createElement(
              'span',
              { className: arrowButtonClassName },
              _I18n2.default.text(I18N_PREFIX + '.lastPage.label')
            ),
            _react2.default.createElement(_UIIcon2.default, { className: 'private-paginator__icon', name: 'last' })
          ) : null
        )
      );
    }
  }]);

  return UIPaginator;
}(_react.PureComponent);

UIPaginator.propTypes = {
  className: _propTypes2.default.string,
  disabledPageTooltipTitle: _propTypes2.default.node,
  maxVisiblePageButtons: _propTypes2.default.number,
  onPageChange: _propTypes2.default.func.isRequired,
  page: _propTypes2.default.number.isRequired,
  pageCount: _propTypes2.default.number.isRequired,
  enabledPageLimit: _propTypes2.default.number,
  showFirstLastButtons: _propTypes2.default.bool.isRequired,
  showButtonLabels: _propTypes2.default.bool.isRequired
};

UIPaginator.defaultProps = {
  maxVisiblePageButtons: 11,
  showFirstLastButtons: false,
  showButtonLabels: true,
  page: 1
};

UIPaginator.displayName = 'UIPaginator';

exports.default = (0, _Controllable2.default)(UIPaginator, ['page']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/paginator/UIPaginator.js
// module id = 607
// module chunks = 177